
/** Header elements are loaded */
export const triggerHeaderLoaded = () => {
    const event = new Event("xf_header_loaded");
    window.dispatchEvent(event);
    // console.log('triggerHeaderLoaded');
    // console.log(event);
    
}

/** Change in the storage event - from the another tab/window */
const storageEventCallback = (e) => {
    // console.log('storage event');
    // console.log(e);
}
export const addStorageListener = () => {
    window.addEventListener("storage", storageEventCallback)
}

export const removeStorageListener = () => {
    window.removeEventListener('storage', storageEventCallback)
}

/** User change Events */
const userEventCallback = (e, dispatchUser) => {
    // console.log("xf_user_change event".toUpperCase());
    dispatchUser({
        type: "user_change"
    })
}
export const addUserListener = (dispatchUser) => {
    window.addEventListener("xf_user_change", e => userEventCallback(e, dispatchUser));  
}

export const removeUserListener = (dispatchUser) => {
    window.removeEventListener("xf_user_change", e => userEventCallback(e, dispatchUser))
}

export const triggerUserLogOutEvent = async (dispatchUser) => {
    // console.log('trigger User LogOut Event'.toUpperCase());
    // TODO: log-out function 

    const event = new Event("xf_user_logout");
    window.dispatchEvent(event);
}

const userLogoutEventCallback = async (e, user, dispatchUser) => {
    // console.log('user Logout Event Callback'.toUpperCase());
    // let logout = await LogOutUser(user.client_id, user.connection_id)
    // console.log(logout);
    dispatchUser({type: "log_out", payload: ''})       
}
export const addUserLogoutListener = (user, dispatchUser) => {
    window.addEventListener('xf_user_logout', e => userLogoutEventCallback(e, user, dispatchUser))
}
export const removeUserLogoutListener = (user, dispatchUser) => {
    window.removeEventListener('xf_user_logout', e => userLogoutEventCallback(e, user, dispatchUser))
}

/** Switch page in the app events */
const pageEventCallback = (e) => {
    // console.log('page event callback');
    // console.log(e);
}
export const addPageListener = () => {
    window.addEventListener('xf_page_change', pageEventCallback)
}
export const removePageListener = () => {
    window.removeEventListener('xf_page_change', pageEventCallback)
}
export const triggerPageEvent = () => {
    
    const event = new Event("xf_page_change");
    window.dispatchEvent(event);
    // console.log('trigger Page Event'.toUpperCase());
    
}